import { render, staticRenderFns } from "./DpCharts.component.vue?vue&type=template&id=c2c649c8&scoped=true&"
import script from "./DpCharts.component.vue?vue&type=script&lang=js&"
export * from "./DpCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./DpCharts.component.vue?vue&type=style&index=0&id=c2c649c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c649c8",
  null
  
)

export default component.exports